var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "h5",
        { staticClass: "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold" },
        [
          _vm._t("title", function () {
            return [_vm._v("Контракт")]
          }),
        ],
        2
      ),
      _c("b-table", {
        staticClass: "table-atmo",
        attrs: {
          busy: _vm.isDataSending,
          fields: _vm.fields,
          items: _vm.supplementaryAgreement.supplementary_agreement_files,
          small: "",
          responsive: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(created_at)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatDateTime(data.item.created_at)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(contract_attachment)",
            fn: function (data) {
              return [
                data.item.is_archived ? [_vm._v("(Архив) ")] : _vm._e(),
                _c(
                  "a",
                  {
                    staticClass: "atmo-button-link",
                    attrs: {
                      href: _vm.$getAttachmentDownloadLink(
                        data.item.supplementary_agreement_attachment.id
                      ),
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(data.item.supplementary_agreement_attachment.name)
                    ),
                  ]
                ),
                !data.item.is_archived &&
                _vm.supplementaryAgreement.status.subtitle
                  ? _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.supplementaryAgreement.status.subtitle) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(contract_with_signature)",
            fn: function (data) {
              return [
                !data.item.is_archived && _vm.supplementaryAgreement.zip_name
                  ? _c("action-button-small", {
                      staticClass: "ml-1",
                      attrs: {
                        icon: "file-earmark-zip",
                        title: "Скачать одним файлом",
                        variant: "outline",
                      },
                      on: { click: _vm.downloadZip },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(sign_customer)",
            fn: function (data) {
              return [
                data.item.supplementary_agreement_attachment.customer_signature
                  ? [
                      _c("action-button-small", {
                        attrs: {
                          icon: "clipboard-check",
                          title: "Информация о подписи",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showSign(
                              true,
                              data.item.supplementary_agreement_attachment
                                .customer_signature
                            )
                          },
                        },
                      }),
                      data.item.supplementary_agreement_attachment
                        .customer_signature.poa_number &&
                      data.item.supplementary_agreement_attachment
                        .customer_signature.poa_check_link
                        ? _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "clipboard-plus",
                              title: "Информация о МЧД",
                              variant: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showSign(
                                  true,
                                  data.item.supplementary_agreement_attachment
                                    .customer_signature
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _c("action-button-small", {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "cloud-download",
                          title: "Скачать файл подписи",
                          variant: "outline",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.download(
                              data.item.supplementary_agreement_attachment
                                .customer_signature.md5,
                              true,
                              data.item.supplementary_agreement_attachment.name
                            )
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(sign_supplier)",
            fn: function (data) {
              return [
                data.item.supplementary_agreement_attachment.supplier_signature
                  ? [
                      _c("action-button-small", {
                        attrs: {
                          icon: "clipboard-check",
                          title: "Информация о подписи",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showSign(
                              false,
                              data.item.supplementary_agreement_attachment
                                .supplier_signature
                            )
                          },
                        },
                      }),
                      data.item.supplementary_agreement_attachment
                        .supplier_signature.poa_number &&
                      data.item.supplementary_agreement_attachment
                        .supplier_signature.poa_check_link
                        ? _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "clipboard-plus",
                              title: "Информация о МЧД",
                              variant: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showSign(
                                  false,
                                  data.item.supplementary_agreement_attachment
                                    .supplier_signature
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _c("action-button-small", {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "cloud-download",
                          title: "Скачать файл подписи",
                          variant: "outline",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.download(
                              data.item.supplementary_agreement_attachment
                                .supplier_signature.md5,
                              false,
                              data.item.supplementary_agreement_attachment.name
                            )
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm.signData.signature
        ? _c("show-sign-modal", {
            attrs: {
              signature: _vm.signData.signature,
              "org-is-customer": _vm.signData.isCustomer,
              show: _vm.showSignModal,
            },
            on: {
              close: function ($event) {
                _vm.showSignModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }